// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pageContentMain {
  height: calc(100vh - 41px);
  overflow: auto;
}

.page-title {
  padding: 5px 10px;
  font-size: 20px;
  color: #2a2e32;
}

.sub-title {
  padding: 5px 10px;
  font-size: 17px;
  color: #2a2e32;
}

.page-titleRow {
  float: left;
  width: 100%;
  background: #fff;
  box-shadow: 1px 1px 4px #e6e6e6;
}

.container-height {
  padding: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/analytics/analytic-dashboards/analytic-dashboards.component.scss"],"names":[],"mappings":"AAAA;EACI,0BAAA;EACA,cAAA;AACJ;;AAGA;EACI,iBAAA;EACA,eAAA;EACA,cAAA;AAAJ;;AAGA;EACI,iBAAA;EACA,eAAA;EACA,cAAA;AAAJ;;AAGA;EACI,WAAA;EACA,WAAA;EACA,gBAAA;EACA,+BAAA;AAAJ;;AAqCA;EACI,qBAAA;AAlCJ","sourcesContent":[".pageContentMain {\r\n    height: calc(100vh - 41px);\r\n    overflow: auto;\r\n    //margin-top: 41px;\r\n}\r\n\r\n.page-title {\r\n    padding: 5px 10px;\r\n    font-size: 20px;\r\n    color: #2a2e32;\r\n}\r\n\r\n.sub-title {\r\n    padding: 5px 10px;\r\n    font-size: 17px;\r\n    color: #2a2e32;\r\n}\r\n\r\n.page-titleRow {\r\n    float: left;\r\n    width: 100%;\r\n    background: #fff;\r\n    box-shadow: 1px 1px 4px #e6e6e6;\r\n}\r\n\r\n// .listvalues-lft .nav-pills .nav-link {\r\n//     font-size: 13px;\r\n//     color: #484b4e;\r\n//     padding: 8px 4px 8px 10px;\r\n//     border-radius: 0;\r\n//     border-bottom: 1px solid #e6e6e6;\r\n// }\r\n\r\n// .listvalues-lft {\r\n//     height: calc(100vh - 85px);\r\n//     overflow: auto;\r\n// }\r\n// .listvalues-lft .nav-link {\r\n//     padding-left: 20px !important;\r\n//     padding: 6px !important;\r\n// }\r\n// .listvalues-lft .nav-link:hover,.listvalues-lft .nav-link.active{\r\n//     background: #efefef !important;\r\n//     color: #515151 !important;\r\n// }\r\n// .listvalues-lft .sub-title {\r\n//     padding-bottom:0px !important;\r\n//     background: #5d7b92 !important;\r\n//     padding: 5px !important;\r\n//     display: block;\r\n//     color: #fff !important;\r\n// }\r\n// .listvalues-lft .sub-sub-title{\r\n//     background: #e2e2e2 !important;\r\n//     padding-left: 12px !important;\r\n//     border-left: 4px solid #fff;\r\n//     color: #0a0a0a !important;\r\n\r\n// }\r\n.container-height{\r\n    padding: 0 !important\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
